import type { Departure } from "../getDeparture";
import type { Travel } from "../getTravel";

export const BOAT_SECTION_ID = "bateau";

const getBoatMapUrl = (boatMap: string) => `https://storage.googleapis.com/intermedes/boats/${boatMap}`;

export const getDisplayedBoat = (travel: Travel, departure: Departure | null) => {
  if (travel.travelTypeId !== "croisiere" && travel.travelTypeId !== "circuit-croisiere") return null;
  if (!departure) return null;

  const boat = departure.boats[0];
  if (!boat) return null;

  const mapUrl = departure.boatMap ? getBoatMapUrl(departure.boatMap) : null;
  if (boat.images.length === 0 && !boat.description.trim() && !boat.hostingComment.trim() && !mapUrl) return null;

  return { ...boat, mapUrl };
};
